import React, { Component } from 'react';
import { Col, Row, Panel } from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';
import ArrowButton from '../../common/button-arrow';

import expand from '../../../assets/img/performances/Expand@2x.png';
import collapse from '../../../assets/img/performances/Collapse@2x.png';
import './submission.css';
import Submission from './submission';
import SubmissionsSummary from './submissions-summary';
import {
  getUserSubmissions,
  getUserSubmissionsOverview
} from '../../../actions/submissions';

class OutletSubmissions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      submissions: [],
      sortedBy: 'attributes["created-at"]',
      sortDirection: 'asc'
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getUserSubmissionsOverview(this.props.outlet.id));
    dispatch(getUserSubmissions(this.props.outlet.id, 5)).then(() => {
      const submissions = this.props.submissions[this.props.outlet.id]
        ? this.props.submissions[this.props.outlet.id].submissions.data
        : [];

      this.setState(...this.state, { submissions });
    });
  }

  handleClick() {
    this.setState({ open: !this.state.open });
  }

  handleSortBy(sortKey) {
    let sortDirection = 'asc';
    if (this.state.sortedBy === sortKey) {
      sortDirection = this.state.sortDirection === 'asc' ? 'desc' : 'asc';
    }

    const sortedSubmissions = _.orderBy(
      this.state.submissions,
      [sortKey],
      [sortDirection]
    );
    this.setState(...this.state, {
      submissions: sortedSubmissions,
      sortedBy: sortKey,
      sortDirection
    });
  }

  handleGetMore() {
    const { dispatch } = this.props;
    dispatch(getUserSubmissions(this.props.outlet.id)).then(() => {
      const submissions = this.props.submissions[this.props.outlet.id]
        ? this.props.submissions[this.props.outlet.id].submissions.data
        : [];

      this.setState(...this.state, { submissions });
    });
  }

  render() {
    const { outlet, key } = this.props;

    const { submissions, sortedBy } = this.state;
    const outletSubmissionsOverview = this.props.submissionsOverview[outlet.id] || {};
    return (
      <div key={key}>
        <Panel
          className="submissions-panel"
          header={
            (
              <div onClick={() => this.handleClick()}>
                <span className="text-bold">{outlet.attributes.name}</span> |{' '}
                {outlet.attributes['customer-number']}
                <img
                  className='panel-toggle'
                  src={this.state.open ? collapse : expand}
                />
              </div>
            )
          }
          collapsible
          expanded={this.state.open}
        >
          <SubmissionsSummary key={outlet.id} outlet={outlet} />
          { submissions.length > 0 && (
            <div className="outlet-submissions">
              <Row className="outlet-submissions-header">
                <Col
                  xs={2}
                  onClick={() => this.handleSortBy('attributes["created-at"]')}
                >
                  <div className={sortedBy === 'attributes["created-at"]' ? 'active-sort' : null}>
                    <span className="submissions-sort-icon glyphicon glyphicon-triangle-bottom" /> SORT BY DATE
                  </div>
                </Col>
                <Col
                  xs={2}
                  onClick={() => this.handleSortBy('attributes["type"]')}
                >
                  <div className={sortedBy === 'attributes["type"]' ? 'active-sort' : null}>
                    <span className="submissions-sort-icon glyphicon glyphicon-triangle-bottom" /> SORT BY TYPE
                  </div>
                </Col>
                <Col
                  xs={3}
                  onClick={() =>
                    this.handleSortBy('attributes["campaign-name"]')
                  }
                >
                  <div className={sortedBy === 'attributes["campaign-name"]' ? 'active-sort' : null}>
                    <span className="submissions-sort-icon glyphicon glyphicon-triangle-bottom" /> SORT BY CAMPAIGN
                  </div>
                </Col>
                <Col
                  xs={2}
                  onClick={() => this.handleSortBy('attributes["status"]')}
                >
                  <div className={sortedBy === 'attributes["status"]' ? 'active-sort' : null}>
                    STATUS
                  </div>
                </Col>
              </Row>
              {submissions.map(submission => (
                <Submission key={submission.id} submission={submission} />
              ))}
              {submissions.length <
                outletSubmissionsOverview.total_submissions && (
                <div
                  className="more-submissions pull-right"
                  onClick={() => this.handleGetMore()}
                >
                  <span className="glyphicon glyphicon-menu-down" />
                   More submissions
                </div>
              )}
            </div>
          )}
          <div className="submit-epos-button">
            <ArrowButton
              arrow={{ direction: 'right' }}
              className="pull-right"
              color="yellow"
              onClick={() => this.props.handleTabSelect('submit_epos_data')}
              submit={false}
            >
              SUBMIT EPOS/INVOICE
            </ArrowButton>
          </div>
        </Panel>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  submissions: state.submissions.user_submissions || [],
  submissionsOverview: state.submissions.user_submissions_overview || []
});

export default connect(mapStateToProps)(OutletSubmissions);



// WEBPACK FOOTER //
// ./src/components/submissions/dashboard/outlet-submissions.js